import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { UploadStatus } from "../UploadEnums";

const initialState = {
  downloadQueue: []
};

const { actions, reducer } = createSlice({
  name: "download",
  initialState,
  reducers: {
    addFileToQueue: (state, action) => {
      const queueItem = {
        file: action.payload.file,
        fileName: action.payload.fileName,
        status: UploadStatus.PENDING,
        id: new Date().getTime(),
        size: 0,
        progress: 0,
        uploaded: 0,
        blockIds: [],
        blockQueue: []
      };

      state.downloadQueue = [...state.downloadQueue, queueItem];
      toast.success(
        `Bestand ${action.payload.fileName} is toegevoegd aan de wachtrij`
      );
    },

    updateFileStatus: (state, action) => {
      let queue = state.downloadQueue.slice();
      const index = queue.findIndex(x => x.id === action.payload.id);
      queue[index].status = action.payload.status;
      switch (action.payload.status) {
        case UploadStatus.ERROR:
        case UploadStatus.CANCELLED:
        case UploadStatus.COMPLETED:
          queue[index].blockQueue = [];
          break;

        default:
          break;
      }
      state.downloadQueue = queue;
    },

    setCurrentFileProgress: (state, action) => {
      let queue = state.downloadQueue.slice();
      const index = queue.findIndex(x => x.id === action.payload.id);
      const file = queue[index];

      let uploaded = file.uploaded + action.payload.loaded;

      file.uploaded = uploaded;
      if (file.status === UploadStatus.UPLOADING && uploaded) {
        file.progress = Math.floor((uploaded / file.size) * 100);
        state.downloadQueue = queue;
      }
    }
  },
  extraReducers: builder => {}
});

export const { addFileToQueue, updateFileStatus, setCurrentFileProgress } =
  actions;

export default reducer;
